module.exports = __webpack_public_path__ + "img/clutch-award.a1ff3692.png";